import React from 'react';
import Button from '@amzn/awsui-components-core/button';
import CopyToClipboard from '@amzn/awsui-components-core/copy-to-clipboard';
import SpaceBetween from '@amzn/awsui-components-core/space-between';
import { useQuerySqlPreview } from 'src/components/star-grid/hooks/useQuerySqlPreview';
import { useStarGridText } from 'src/components/star-grid/hooks/useStarGridText';
import styles from 'src/components/star-grid/views/styles/ReportDetailView.module.scss';

/** `run`: the SQL as it ran; `code`: as written, with its placeholders. */
export type SqlForm = 'run' | 'code';

/** One executed query: a preview that expands, and a copy button that always copies the full text. */
export const QuerySqlBlock: React.FC<{ sql: string; template?: string | null; form?: SqlForm }> = ({ sql: asRun, template, form = 'run' }) => {
  const text = useStarGridText();
  const sql = form === 'code' ? template ?? asRun : asRun;
  const { preview, expanded, toggle } = useQuerySqlPreview(sql);
  return (
    <SpaceBetween size="xs">
      <pre className={styles.querySql} data-testid="report-query-sql">
        {preview.text}
      </pre>
      <SpaceBetween direction="horizontal" size="xs">
        <CopyToClipboard
          variant="button"
          textToCopy={sql}
          copyButtonText={text('querySqlCopy')}
          copySuccessText={text('querySqlCopied')}
          copyErrorText={text('querySqlCopyFailed')}
        />
        {preview.truncatable && (
          <Button variant="inline-link" onClick={toggle}>
            {expanded ? text('querySqlShowLess') : text('querySqlShowAll')}
          </Button>
        )}
      </SpaceBetween>
    </SpaceBetween>
  );
};
